import { render, staticRenderFns } from "./iframe-view.vue?vue&type=template&id=33dd01a3"
import script from "./iframe-view.vue?vue&type=script&lang=js"
export * from "./iframe-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports